import AnnouncementBar from "@/components/aeonyx/AnnouncementBar";
import Header from "@/components/aeonyx/Header";
import Footer from "@/components/aeonyx/Footer";
import QualityControl from "@/components/aeonyx/QualityControl";
import LegalDisclaimer from "@/components/aeonyx/LegalDisclaimer";
import { useScrollReveal } from "@/lib/useScrollReveal";

export default function QualityControlPage() {
  useScrollReveal();
  return (
    <div className="bg-cool-white">
      <AnnouncementBar />
      <Header />
      <div className="pt-6"><QualityControl /></div>
      <LegalDisclaimer />
      <Footer />
    </div>
  );
}
